import { useEffect, useMemo, useState, type ReactNode } from 'react';
import { apiClient } from 'utils/api';
import TextsContext from './TextsContext';
import { useWidgetCommunication } from 'components/communication';
import type { Texts } from './types';

type Props = { children: ReactNode };

const TextsProvider = ({ children }: Props) => {
  const [texts, setTexts] = useState<Texts>();
  const { culture } = useWidgetCommunication() || {};

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      try {
        culture && setTexts(await apiClient.get<Texts>('/texts', { signal: controller.signal }));
      } catch (error) {
        if (error instanceof Error && error.name === 'AbortError')
          return;

        console.error(error);
      }
    };

    load();

    return () => { controller.abort(); };
  }, [culture]);

  const value = useMemo(() => ({ texts }), [texts]);

  return <TextsContext.Provider value={value}>{children}</TextsContext.Provider>;
};

export default TextsProvider;
